import { OneTrustConsentGroups } from '~/enums';
import { logToSentry } from './loggers.helper';
import { getCookieValue } from './utils';

const OPTANON_CONSENT_COOKIE = 'OptanonConsent';
const GROUP_CONSENT_GRANTED = '1';

export const USER_OPTED_IN_EVENT_NAME = 'user_opted_in_event_capturing';

/**
 * Reads the OneTrust groups the user has consented to from the OptanonConsent cookie.
 * The cookie is set on the parent domain, so it holds a decision made on the marketing
 * site before the OneTrust script has loaded here.
 *
 * @returns the consented group ids, e.g. ['C0001', 'C0002'], or null when the user has not
 * made a decision yet, so "no decision" is kept apart from "rejected"
 */
export const getConsentedGroupsFromCookie = (): string[] | null => {
  try {
    const cookieValue = getCookieValue(OPTANON_CONSENT_COOKIE);
    if (!cookieValue) return null;

    // groups=C0001:1,C0002:0 where 1 means consented and 0 means rejected
    const groups = new URLSearchParams(cookieValue).get('groups');
    if (!groups) return null;

    return groups
      .split(',')
      .map((group) => group.split(':'))
      .filter(([, status]) => status === GROUP_CONSENT_GRANTED)
      .map(([groupId]) => groupId);
  } catch (error) {
    // getCookieValue decodes every cookie, so one malformed cookie must not break the app
    logToSentry(error, 'Error reading OneTrust consent cookie');
    return null;
  }
};

export const hasPerformanceCookieConsent = (groups: string[]): boolean =>
  groups.includes(OneTrustConsentGroups.PerformanceCookies);
